import { DateTime } from "luxon";
import { ControllerRenderProps } from "react-hook-form";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./select";

const timezones = [
  {
    label: "North America",
    items: [
      { value: "America/New_York", label: "Eastern Time" },
      { value: "America/Chicago", label: "Central Time" },
      { value: "America/Denver", label: "Mountain Time" },
      { value: "America/Los_Angeles", label: "Pacific Time" },
      { value: "America/Anchorage", label: "Alaska Time" },
      { value: "Pacific/Honolulu", label: "Hawaii Time" },
    ],
  },
  {
    label: "Europe & Africa",
    items: [
      { value: "Europe/London", label: "Greenwich Mean Time" },
      { value: "Europe/Paris", label: "Central European Time" },
      { value: "Europe/Athens", label: "Eastern European Time" },
      { value: "Europe/Lisbon", label: "Western European Summer Time" },
      { value: "Africa/Harare", label: "Central Africa Time" },
      { value: "Africa/Nairobi", label: "East Africa Time" },
    ],
  },
  {
    label: "Asia",
    items: [
      { value: "Europe/Moscow", label: "Moscow Time" },
      { value: "Asia/Kolkata", label: "India Standard Time" },
      { value: "Asia/Shanghai", label: "China Standard Time" },
      { value: "Asia/Tokyo", label: "Japan Standard Time" },
      { value: "Asia/Seoul", label: "Korea Standard Time" },
      { value: "Asia/Makassar", label: "Indonesia Central Time" },
    ],
  },
  {
    label: "Australia & Pacific",
    items: [
      { value: "Australia/Perth", label: "Western Standard Time" },
      { value: "Australia/Darwin", label: "Central Standard Time" },
      { value: "Australia/Sydney", label: "Eastern Standard Time" },
      { value: "Pacific/Auckland", label: "New Zealand Standard Time" },
      { value: "Pacific/Fiji", label: "Fiji Time" },
    ],
  },
  {
    label: "South America",
    items: [
      { value: "America/Argentina/Buenos_Aires", label: "Argentina Time" },
      { value: "America/La_Paz", label: "Bolivia Time" },
      { value: "America/Sao_Paulo", label: "Brasilia Time" },
      { value: "America/Santiago", label: "Chile Standard Time" },
    ],
  },
];

export default function TimezoneSelect({
  field,
}: {
  field: ControllerRenderProps<{ name: string; timezone: string }>;
}) {
  return (
    <Select onValueChange={field.onChange} defaultValue={field.value}>
      <SelectTrigger className="">
        <SelectValue placeholder="Select a timezone" />
      </SelectTrigger>
      <SelectContent>
        {timezones.map((group) => (
          <SelectGroup key={group.label}>
            <SelectLabel>{group.label}</SelectLabel>
            {group.items.map((item) => {
              const localTime = DateTime.now()
                .setZone(item.value)
                .toFormat("h:mm a");
              return (
                <SelectItem key={item.value} value={item.value}>
                  {`${item.label} (${localTime})`}
                </SelectItem>
              );
            })}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
